<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-long-arrow-left"></i> Devolución de Facturas
      <div class="card-header-actions btn-group" dropdown placement="bottom left">
        <button type="button" (click)="create()" class="btn btn-sm btn-outline-success"><i
            class="fa fa-plus"></i>&nbsp;Crear Orden de Devolución</button>
        <button type="button" (appPrivilegeClick)="createManual()" class="btn btn-sm btn-outline-success"
          appPrivilege="doManualReturn"><i class="fa fa-regular fa-square-plus"></i>&nbsp;Crear Orden de Devolución
          Factura
          MT</button>

      </div>
    </div>
    <div class="card-body">
      <pos-table [data]="orders" [itemsPerPage]="10" (dataChange)="getData($event)" [headers]="getHeaders()"
        [filters]="getFilters()" [disableHighlight]="true">
      </pos-table>
    </div>
  </div>
</div>